import { TimesheetSettingsType } from 'api/customer/types';
import {
    SubmitReportPayload,
    Timesheet,
    TimesheetDay,
    TimesheetDayPayload,
    TimesheetPayload,
    Travelsheet,
    TravelsheetPayload,
} from 'api/report/types';

export function buildTimesheetPayload(
    timesheet: Timesheet,
    reportTemplateID: number,
    enableSickHours: boolean
): SubmitReportPayload & { data: TimesheetPayload } {
    return {
        reportTemplateID,
        data: {
            days: (timesheet.days ?? []).map(day =>
                buildTimesheetDayPayload(
                    day,
                    enableSickHours,
                    timesheet.timesheetSetting
                )
            ),
            notes: timesheet.notes,
            travelsheet: timesheet.travelsheet
                ? buildTravelsheetPayload(timesheet.travelsheet)
                : null,
        },
    };
}

function buildTimesheetDayPayload(
    day: TimesheetDay,
    enableSickHours: boolean,
    setting: TimesheetSettingsType
): TimesheetDayPayload {
    return {
        hours: [...day.hours],
        sickHours: enableSickHours ? [...day.sickHours] : [],
        intervals:
            setting === TimesheetSettingsType.NORMAL
                ? []
                : day.intervals
                      .filter(
                          interval => enableSickHours || !interval.isSickHours
                      )
                      .map(interval => ({
                          start: interval.start,
                          stop: interval.stop,
                          breakInMinutes: interval.breakInMinutes,
                          isSickHours: interval.isSickHours,
                      })),
    };
}

function buildTravelsheetPayload(travelsheet: Travelsheet): TravelsheetPayload {
    return {
        travel1: travelsheet.travel1 && [...travelsheet.travel1],
        travel2: travelsheet.travel2 && [...travelsheet.travel2],
        travel3: travelsheet.travel3 && [...travelsheet.travel3],
        travel4: travelsheet.travel4 && [...travelsheet.travel4],
        travel5: travelsheet.travel5 && [...travelsheet.travel5],
        travel6: travelsheet.travel6 && [...travelsheet.travel6],
        travel7: travelsheet.travel7 && [...travelsheet.travel7],
    };
}
